import { Subject } from 'rxjs';
export interface DrawerResult<T = any> {
  valid: boolean;
  data?: T;
}

export class DrawerRef<T = any> {

  private closeSubject = new Subject<T>();

  afterClosed$ = this.closeSubject.asObservable();

  close(result?: T) {
    this.closeSubject.next(result);
    this.closeSubject.complete();
  }

}
